import React from 'react'
import useActivityStatuses from '../../shared/hooks/useActivityStatuses'
import SettingsSelect from '../../shared/components/SettingsSelect/SettingsSelect'

interface ActivityStatusFieldProps {
    value: string
    onChange: (val: string) => void
    disabled?: boolean
    existingValue?: string
    error?: boolean
    helperText?: string
    required?: boolean
}

const ActivityStatusField: React.FC<ActivityStatusFieldProps> = ({
    value,
    onChange,
    disabled,
    existingValue,
    error,
    helperText,
    required,
}) => {
    const { activityStatusDetails } = useActivityStatuses()
    const options = activityStatusDetails.map((s) => ({ value: s.id, label: s.name }))

    return (
        <SettingsSelect
            value={value}
            onChange={onChange}
            options={options}
            placeholder="Select Status"
            disabled={disabled}
            existingValue={existingValue}
            error={error}
            helperText={helperText}
            required={required}
        />
    )
}

export default ActivityStatusField
